/**
 * Hand-drawn vintage ornamental divider — pure SVG.
 * Use to break sections with fairy-tale flourish.
 */
export default function OrnamentalDivider({ className = "", color = "var(--c-firefly-gold)" }) {
  return (
    <div className={`flex items-center justify-center my-8 ${className}`} aria-hidden="true">
      <svg viewBox="0 0 600 60" className="w-full max-w-2xl h-12" preserveAspectRatio="xMidYMid meet">
        <defs>
          <linearGradient id="ornGrad" x1="0%" x2="100%">
            <stop offset="0%" stopColor={color} stopOpacity="0" />
            <stop offset="20%" stopColor={color} stopOpacity="0.7" />
            <stop offset="50%" stopColor={color} stopOpacity="1" />
            <stop offset="80%" stopColor={color} stopOpacity="0.7" />
            <stop offset="100%" stopColor={color} stopOpacity="0" />
          </linearGradient>
        </defs>
        {/* Left flourish */}
        <path
          d="M40,30 Q80,10 120,30 T200,30 Q220,40 240,30"
          fill="none"
          stroke="url(#ornGrad)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M80,30 Q90,20 100,30 Q90,40 80,30 Z"
          fill={color}
          opacity="0.5"
        />
        {/* Center: 4-pointed star */}
        <g transform="translate(300,30)">
          <path d="M0,-18 L4,-4 L18,0 L4,4 L0,18 L-4,4 L-18,0 L-4,-4 Z" fill={color} />
          <circle r="3" fill="var(--c-bio-green)" />
        </g>
        {/* Right flourish */}
        <path
          d="M360,30 Q380,20 400,30 T480,30 Q520,10 560,30"
          fill="none"
          stroke="url(#ornGrad)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M520,30 Q510,20 500,30 Q510,40 520,30 Z"
          fill={color}
          opacity="0.5"
        />
        {/* Side dots */}
        <circle cx="250" cy="30" r="2" fill={color} opacity="0.7" />
        <circle cx="350" cy="30" r="2" fill={color} opacity="0.7" />
      </svg>
    </div>
  );
}
